import config from '@/config';
import SDK from '@/lib/NIM_Web_NIM_v6.2.0';
import {onRoamingMsgs, onOfflineMsgs, onMsg} from './msgs'

//const SDK = require(`@/lib/${config.IMSdk}`);

/**
 * 重新初始化 NIM SDK
 * @param {*} store对象
 * @param {*} loginInfo {uid:'宝宝树uid',sdktoken:'数据来源于接口http://mapiweb.babytree.com/newapi/im/action，参考文档：http://space.dayin.com/pages/viewpage.action?pageId=15323025#id-22.MAPI%E5%8D%81%E6%9C%9F%E6%9A%B4%E9%9C%B2%E6%8E%A5%E5%8F%A3-%E8%8E%B7%E5%8F%96token'}
 */
export function initNimSDK({ state, commit, dispatch }, loginInfo) {
  if (state.nim) {
        // 登出 SDK
    state.nim.disconnect();
  }

  window.nim = state.nim = NIM.getInstance({
    debug: config.debug, // 是否开启调试, 如果开启调试, 将会在控制台输出一些log。默认false不输出日志, 可以传true来开启日志。
    appKey: config.IMappKey, // 应用key，config配置文件写死.
    account: loginInfo.uid, // 宝宝树用户id,
    token: loginInfo.sdktoken, // token，用uid调用接口去换取的token
        // transports: ['websocket'],//用于建立长连接的协议数组，可不填，默认为['websocket', 'xhr-polling']
    db: false, // 是否开启本地数据库存储数据，参数为：true/false，使用 indexedDb
    needReconnect: true, // 连接失败时是否需要自动重连
    syncSessionUnread: true, // 是否同步会话未读数(开启数据库时有效，保证多端未读数相一致)
    syncRobots: true, // 是否同步机器人列表，默认false, 如果传false就收不到onrobots回调。
    autoMarkRead: true, // 对收到的消息，是否自动标记为已读
        // //连接建立后的回调, 会传入一个对象, 包含登录的信息, 有以下字段
    onconnect: function onConnect(event) {
      if (loginInfo) {
              // 连接上以后更新uid
        commit('updateUserUID', loginInfo);
      }
    },
        // 发生错误的回调, 会传入错误对象
    onerror: function onError(event) {
            // alert(JSON.stringify(event))
      debugger;
      alert('网络连接状态异常');
    },
        // 此时说明 `SDK` 已经断开连接, 需要在界面上提示用户正在重新连接.
    onwillreconnect: function onWillReconnect(obj) {
      console.log(obj);
    },
    ondisconnect: function onDisconnect(error) {
      switch (error.code) {
        // 账号或者密码错误, 请跳转到登录页面并提示错误
        case 302:
        // pageUtil.turnPage('帐号或密码错误', 'login')
          alert('帐号或密码错误');
          break;
              // 被踢, 请提示错误后跳转到登录页面
        case 'kicked':
          alert('您的账号被踢下线');
          break;
        default:
          break;
      }
    },
    onloginportschange: function onLoginPortsChange(loginPorts) {
      console.log('当前登录帐号在其它端的状态发生改变了', loginPorts);
    },
        // 回话
        // onupdatesession: onUpdateSession,
        // 消息
    onroamingmsgs: onRoamingMsgs, // 同步漫游消息的回调, 每个会话对应一个回调, 会传入消息数组
    onofflinemsgs: onOfflineMsgs, // 同步离线消息的回调, 每个会话对应一个回调, 会传入消息数组
    onmsg: onMsg// 收到消息的回调, 会传入消息对象


  });
}



// WEBPACK FOOTER //
// ./src/store/nim/initNimSDK.js